export const API_URL = process.env.REACT_APP_API_URL;
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL;

export const END_POINTS = {
  login: "/sp/onboarding/login",
  signup: "/sp/onboarding/send-otp",
  forgotPassword: "/sp/onboarding/send-otp",
  sendOtp: "/sp/onboarding/send-otp",
  verifyOtp: "/sp/onboarding/verify-otp",
  resetPassword: "/sp/onboarding/change-password",
  changePassword: "/sp/onboarding/change-password",
  updateProfile: "/sp",
  logout: "user/logout",
  upload: "/sp/media2",
  media2: "/sp/media2",
  getProfile: "/vendor/serviceProvider",
  myProfile: "/sp/onboarding",
  sendOtpToVerify: "/sp/onboarding/verify/send-otp",
  verifyOtpToVerify: "/sp/onboarding/verify/verify-otp",

  //category
  category: "/sp/category",

  //services
  services: "/sp/services/add",
  servicesList: "/sp/services/list",
  serviceById: "/sp/services",
  toggleService: "/sp/services/toggle",

  //portfolio
  portfolioList: "/sp/portfolio/list",
  portfolios: "/sp/portfolio/add",
  portfoliById: "/sp/portfolio",
  portfoliDetailsById: "/sp/portfolio",


  //discount
  discountList: "/sp/coupons/list",
  discounts: "/sp/coupons/add",
  discountById: "/sp/coupons",
  toggleDiscount: "/sp/coupons/toggle",

  //rating
  ratingList: "/sp/ratings/list",
  ratingReply: "sp/ratings/reply",

  //booking
  bookingList: "/sp/booking/list",
  replyRating: "/sp/ratings/reply",
  bookingDetailsById: "/sp/booking",
  bookingUpdate: "/sp/booking/update",
  bookingStats: "sp/booking/stats",
  bookingExportCsv: "sp/booking/csv",

  //support
  knowledgeBase: "/sp/knowledge/list",
  knowledgeById: "/sp/knowledge",
  knowledgeLike: "/sp/knowledge/like",
  tutorial: "/sp/tutorial/list",
  tutorialById: "/sp/tutorial",
  tutorialLike: "/sp/tutorial/like",
  faqListing: "/sp/cms/faq",
  cms: "/sp/cms",

  //tickets
  tickets: "/sp/tickets",
  ticketsStats: "/sp/tickets/stats",

  //chat
  chatList: "/chat",
  deleteChat: "/chat/session",

  //earnings
  earnings: "/sp/payouts/earnings",
  payoutsHistory: "/sp/payouts/history",
  payoutsBalance: "/sp/payouts/balance",
  payoutsStats: "/sp/booking/payout/stats",
  payoutAccountStatus: "/sp/payouts/connect/account-status",
  payoutOnboardingLink: "/sp/payouts/connect/onboarding-link",
  payoutRequestInformation: "/sp/payouts/connect/request-information",


  //dashbaord
  dashboardtables: "/sp/dashboard",
  dashboardAnalytics: "/sp/dashboard/analytics",
  dashboardGraphs: "/sp/dashboard/graphs",

  //notifications
  notifications: "/sp/notifications",
  readAllNotifications: "/sp/notifications/read-all",
  spSubscription: "/sp/subscription"
};